/*mapbox卷帘工具*/
class Roller_tool {

  constructor(options = {}) {
    this.map_left = options.map
    this.map_right = ''
    this.compare_map = ''
    this.right_dom_id = options.right_dom_id
    this.compare_dom_id = options.compare_dom_id
    this.roller_line_class = options.roller_line_class
  }

  /**
   * @param type 卷帘类型（水平卷帘，垂直卷帘）
   * @param roll_layer_id 卷掉的图层
   */
  do_roller(type = '水平卷帘',roll_layer_id = []){

    /*不是卷帘，就执行卸载*/
    if(type != "水平卷帘" && type != "垂直卷帘"){
      this.remove()
      return
    }

    let roller_type = "vertical"
    if(type == '垂直卷帘'){
      roller_type = "horizontal"
    }

    /*是否是改变卷帘方向*/
    let is_chanage_directino = false
    if(this.map_right){
      is_chanage_directino = true
    }

    return  this.do_roller_map(roller_type,roll_layer_id,is_chanage_directino)

  }

  /*显示卷帘地图*/
  /**
   * 卷帘浏览
   * @param type 垂直还是水平
   * @param roll_layer_id 被卷掉的图层地
   */
  do_roller_map(type = 'vertical',roll_layer_id ,is_chanage_direction = false,right_style = ''){

    /*通过主地图获取style和位置信息*/
    let main_map = this.map_left
    let style = right_style || ""

    /*如果是换方向，走换方向代码*/
    if(is_chanage_direction && this.map_right){
   /*   this.remove_compare_map()
      let mapboxgl = window.vue.GLOBAL.common_tool.get_mapboxgl()
      /!*执行卷帘联动*!/
      this.compare_map = new mapboxgl.Compare(this.map_left, this.map_right, "#" + this.compare_dom_id, {
        mousemove: false, // Optional. Set to true to enable swiping during cursor movement.
        orientation: type // Optional. Sets the orientation of swiper to horizontal or vertical, defaults to vertical
      });


      return
*/

      style = this.map_right.getStyle()
    }else if(!right_style){
      style = main_map.getStyle()
    }
    /*卷掉roll_layer_id*/
    if(roll_layer_id && roll_layer_id.length > 0){
      style.layers.forEach(item_l => {
        if(roll_layer_id.includes(item_l.id)){
          item_l.layout ? item_l.layout.visibility = 'none' : item_l.layout = {visibility:'none'}
        }
      })
    }

    let center = main_map.getCenter();
    let zoom = main_map.getZoom()

    /*如果有对比地图实例，先将其清除,再修改卷帘方向*/
    if(this.compare_map){
      this.remove_compare_map()
      this.remove_right_map()
    }

    /*去掉绘制工具添加的图层*/
    style.layers = style.layers.filter(item => {return !item.id.includes("gl-draw")})
    let style_keys = Object.keys(style.sources)
    style_keys.forEach(item =>{
      if(item.includes("mapbox-gl-draw")){
        delete style.sources[item]
      }
    })

    let mapboxgl = window.vue.GLOBAL.common_tool.get_mapboxgl()

    /*实例化对比地图*/
    let map = new mapboxgl.Map({
      container: this.right_dom_id,
      style: style,
      center: center,
      zoom:zoom,
      doubleClickZoom: false,
      maxZoom: sys_map_max_zoom || 18,
      transformRequest: (url, resourceType) => {
        let arr = sys_authority_url
        let is_autho =false
        arr.forEach(item => {
          if(url.includes(item)){
            is_autho =true
          }
        })
        if(is_autho){
          return {
            url: url,
            headers: {"Authorization": window.vue.GLOBAL.common_tool.get_token()},
          }
        }
      }
    });

    /*回显marker*/
  /*  window.GLOBAL.sys_marker_tool.review_marker({
      from_map:window.GLOBAL.common_store.sys_map,
      to_map:map
    })*/


    /*记录右侧地图实例*/
    this.map_right = map

    setTimeout(() => {
      map.addControl(new mapboxgl.ScaleControl({maxWidth: 101, unit: 'metric'}), 'bottom-right');//比例尺
      map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');//导航条
      /*添加绘制工具*/
      window.GLOBAL.map_tool.add_map_draw(map)
    },sys_2D_map_delay_time)

    /* map.on("load", () => {
       map.addControl(new mapboxgl.ScaleControl({maxWidth: 101, unit: 'metric'}), 'bottom-right');//比例尺
       map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');//导航条
       /!*添加绘制工具*!/
       window.GLOBAL.map_tool.add_map_draw(map)
     });*/

    map.on('styledata', () => {//解决canvas渲染不正确
      map.resize();
    });

    this.do_main_map_resize()

    /*执行卷帘联动,这里延迟，不然白屏*/
    setTimeout( () => {
      this.compare_map = new mapboxgl.Compare(this.map_left, this.map_right, "#" + this.compare_dom_id, {
        scroll_line_class:this.roller_line_class,
        mousemove: false, // Optional. Set to true to enable swiping during cursor movement.
        orientation: type // Optional. Sets the orientation of swiper to horizontal or vertical, defaults to vertical
      });
    },100)


    return {
      map_right:this.map_right,
    }
  }


  /*关闭对比*/
  remove(){
    this.remove_compare_map()
    this.remove_right_map()
    /*主地图resize*/
    setTimeout(() => {
      this.map_left.resize()
    },100)
  }

  /*清除对比地图*/
  remove_compare_map(){
    let compare_map = this.compare_map
    if(compare_map){
      compare_map.remove()
      this.compare_map = ''
    }
  }

  /*清除右侧地图*/
  remove_right_map(){
    if(this.map_right){
      this.map_right.remove()
      this.map_right = ""
    }
  }

  /*重置主页地图大小*/
  do_main_map_resize(){
    let map_left = this.map_left
    let map_right = this.map_right
    map_left.resize()
    map_right.resize()

    setTimeout(() => {
      map_left.resize()
      map_right.resize()
    },100)
  }

}

export default Roller_tool



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/roller_tool.js